import { motion, useInView } from "framer-motion";
import { useRef } from "react";

interface FadeInProps {
	children: React.ReactNode;
	className?: string;
	delay?: number;
	direction?: "up" | "down" | "left" | "right" | "none";
	duration?: number;
	fullWidth?: boolean;
}

export default function FadeIn({
	children,
	className = "",
	delay = 0,
	direction = "up",
	duration = 0.5,
	fullWidth = false,
}: FadeInProps) {
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, margin: "-50px" });

	const getInitialProps = () => {
		switch (direction) {
			case "up":
				return { opacity: 0, y: 40 };
			case "down":
				return { opacity: 0, y: -40 };
			case "left":
				return { opacity: 0, x: 40 };
			case "right":
				return { opacity: 0, x: -40 };
			case "none":
			default:
				return { opacity: 0 };
		}
	};

	const getAnimateProps = () => {
		switch (direction) {
			case "up":
			case "down":
				return { opacity: 1, y: 0 };
			case "left":
			case "right":
				return { opacity: 1, x: 0 };
			case "none":
			default:
				return { opacity: 1 };
		}
	};

	return (
		<motion.div
			ref={ref}
			initial={getInitialProps()}
			animate={isInView ? getAnimateProps() : getInitialProps()}
			transition={{ duration, delay, ease: "easeOut" }}
			className={className}
			style={{ width: fullWidth ? "100%" : "auto" }}
		>
			{children}
		</motion.div>
	);
}
